module.exports = __webpack_public_path__ + "static/media/institute-6-min.e4d0e737.webp";